import {Mutable, template as tpl} from "./mutable";
import {IObjectData, IRouteDefinitionParams, ISyncField, TRouteId} from "../../index";
import PromiseRequest from "../../req/PromiseRequest";
import {_} from 'lodash';
import {global} from "../../appContext";
import {createErrorMessage} from "../../util/misc";
import {SPINNER} from "../../constants";
import {ISyncFieldMutable} from "./index";
import {convertFromServerString, convertToServerString} from "../../util/datetime";
import {getObjectFromRouteData} from "../../util/request";
import {REQUEST_MESSAGE} from "../../constants/Language";

export let template: string = tpl;

export class viewModel extends Mutable {
    protected reqSubmit = new PromiseRequest("updateobject");

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init();
    }

    protected init() {
        this.objectId = global.getRouteId();
        this.request();
    }

    protected request() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});

        Promise.resolve()
            .then(this.fetchSyncFields.bind(this))
            .then(this.onAllSyncFields.bind(this))
            .then(this.fetchObject.bind(this))
            .then(this.onObjectData.bind(this))
            .then(this.prepareObservableSyncFields.bind(this))
            .then(() => {
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    protected fetchObject(): Promise<IObjectData> {
        return this.__requestRouteData!
            .request()
            .then((data: IObjectData[]) => getObjectFromRouteData(data));
    }

    protected onObjectData(objectData: IObjectData) {
        this.$original = _.cloneDeep(objectData);
        this.$original.syncfields = this.sortSyncFields(this.$original.syncfields)
            .map((sf: ISyncField) => {
                if (sf.value && this.isSyncFieldDate(sf.fieldtype)) {
                    const dateStr = convertToServerString(convertFromServerString(sf.value));
                    sf.value = dateStr ?? '';
                }
                return sf;
            });
    }

    protected prepareObservableSyncFields() {
        const mutableSyncFields: ISyncFieldMutable[] = this.$original!.syncfields
            .filter(sf => !!sf.value || !!sf.required)
            .filter(sf => this.isSyncfieldMutable(sf))
            .map(sf => this.createMutableFromSyncField(sf));
        mutableSyncFields.forEach(o => {
            const syncfield = o.syncfield();
            const tab: TRouteId = syncfield?.required ? 'syncfieldsmandatory' : 'syncfieldsoptional';
            this.__tabManager?.getTab(tab)?.errorManager.addErrorObject(o.errSyncfield)
            this.__tabManager?.getTab(tab)?.errorManager.addErrorObject(o.errValue)
        });
        this.data(mutableSyncFields);
    }

    protected getEventMessage(eventType: "submit" | "success") {
        switch (eventType) {
            case "submit":
                return `((updating|td)) ${SPINNER}`
            case "success": {
                const ret: string[] = ['subject is updated|s:']
                if (this.__routeDef.manual) {
                    ret.push('((manual)) ')
                }
                ret.push(`((${this.__objDef?.translation ?? ''}))`)
                return ret.join('')
            }
        }
    }

}
